export enum AdministrationTabs {
  classrooms = 'classrooms',
  schools = 'schools',
  archivedClassrooms = 'archivedClassrooms',
}
